import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import React, { useMemo } from "react";

import { ISDUIProductTileVariantRendererProps } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileRenderer";
import {
  useGenerateBrandUrlForSDUIProductTileHandler,
  useGenerateProductLinkPropsForSDUIProductTileHandler,
} from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileUrlHandler";
import { ProductImageOnlyTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/ProductImageOnlyTile";

export const SDUIProductTileImageOnlyWithPriceVariantRenderer: React.FC<
  ISDUIProductTileVariantRendererProps
> = ({ product, brand, loggingData, renderBehaviour }) => {
  const brandTile = useMemo(
    () =>
      ILeanProductTile.IBrand.build({
        ...brand,
      }),
    [brand]
  );

  const generateProductLinkProps =
    useGenerateProductLinkPropsForSDUIProductTileHandler(
      product,
      loggingData.view_display_page
    );
  const generateBrandUrl = useGenerateBrandUrlForSDUIProductTileHandler(
    product,
    loggingData.view_display_page
  );

  return (
    <ProductImageOnlyTile
      showPriceBadge
      recordAdImpression
      productTile={product}
      brand={brandTile}
      generateProductLinkProps={generateProductLinkProps}
      generateBrandUrl={generateBrandUrl}
      useLazyImageLoading={renderBehaviour?.imagesLoadingStrategy === "lazy"}
    />
  );
};
